import { Component, Input, OnInit } from "@angular/core";
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";
import { EyeIconComponent } from "../icons/eye/eye.component";

@Component({
  selector: "app-input",
  standalone: true,
  imports: [ReactiveFormsModule, TranslatePipe, EyeIconComponent],
  templateUrl: "./input.component.html",
  styleUrl: "./input.component.css",
})
export class InputComponent implements OnInit {
  @Input()
  label!: string;

  @Input()
  name!: string;

  @Input()
  formGroup!: FormGroup;

  @Input()
  type: string = "text";

  @Input()
  required: boolean = false;

  public isPassword: boolean = false;

  ngOnInit(): void {
    this.isPassword = this.type === "password";

    const control = this.formGroup.get(this.name);
    if (control) {
      const validators = [];

      if (this.required) {
        validators.push(Validators.required);
      }

      if (this.type === "email") {
        validators.push(Validators.email);
      }

      if (validators.length > 0) {
        const currentValidators = control.validator ? [control.validator] : [];
        control.setValidators([...currentValidators, ...validators]);
        control.updateValueAndValidity();
      }
    }
  }

  get control() {
    return this.formGroup.get(this.name);
  }

  get hasError() {
    return this.control?.invalid &&
      (this.control?.dirty || this.control?.touched);
  }

  toggleShowPassword(): void {
    if (this.type !== "text") {
      this.type = "text";
    } else {
      this.type = "password";
    }
  }
}
